// If we grow to international scale and require a set of banks for different locales
// investigate setting a set of banks for that location.
const ukBanks = [
  { bank: 'Atom', uniqueSortCodeIdentifier: '608312' },
  {
    bank: 'Halifax',
    uniqueSortCodeIdentifier: '1100',
  },
  { bank: 'Lloyds', uniqueSortCodeIdentifier: '7749' },
  { bank: 'Hsbc', uniqueSortCodeIdentifier: '4012' },
  {
    bank: 'BankOfScotland',
    uniqueSortCodeIdentifier: '80',
  },
  { bank: 'Barclays', uniqueSortCodeIdentifier: '2026' },
  { bank: 'Metro', uniqueSortCodeIdentifier: '2305' },
  { bank: 'Monzo', uniqueSortCodeIdentifier: '040004' },
  { bank: 'N26', uniqueSortCodeIdentifier: '040026' },
  {
    bank: 'Nationwide',
    uniqueSortCodeIdentifier: '0704',
  },
  {
    bank: 'Natwest',
    uniqueSortCodeIdentifier: '6060',
  },
  { bank: 'Rbs', uniqueSortCodeIdentifier: '1663' },
  { bank: 'Revolut', uniqueSortCodeIdentifier: '040075' },
  {
    bank: 'Santander',
    uniqueSortCodeIdentifier: '0901',
  },
  {
    bank: 'StandardCharteredBank',
    uniqueSortCodeIdentifier: '6091',
  },
  {
    bank: 'Starling',
    uniqueSortCodeIdentifier: '608371',
  },
  { bank: 'Tandem', uniqueSortCodeIdentifier: '608363' },
  { bank: 'Tsb', uniqueSortCodeIdentifier: '8779' },
  {
    bank: 'Transferwise',
    uniqueSortCodeIdentifier: '2314',
  },
  { bank: 'Virgin', uniqueSortCodeIdentifier: '0860' },
];

export const findBank = (sortCodePartial: string | null, banks = ukBanks) => {
  const [match, ...[another]] = banks.filter(({ uniqueSortCodeIdentifier }) =>
    (sortCodePartial || '').startsWith(uniqueSortCodeIdentifier),
  );

  if (match && !another) {
    return match.bank;
  }
};
